var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"action":_vm.action,"method":_vm.method || 'post'},on:{"submit":function($event){$event.preventDefault();return _vm.send.apply(null, arguments)}}},[_vm._t("default",null,{"object":_vm.object,"form":_vm.form,"errors":_vm.errors,"loading":_vm.loading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }